"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 09.11.2018
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var StringLengthValidator_1 = require("../../core/model/data-dictionary/validators/StringLengthValidator");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Entity for dummy window placeholder for a certain sales and margin value that is expected in the total leaflet
 * forecast and used for the time being that the category manager doesn’t know which product will be promoted right now.
 * Margin KPIs are calculated based on promo volume, promo retail price and promo cost price.
 * NOTE: this is just a template for dummy window item in Forecast Sim
 *
 * @author ZSr
 *
 * @param id
 * @param windowName
 * @param articleName
 * @param productId
 */


var DummyWindow =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DummyWindow, _DomainObject_1$Domai);

  function DummyWindow(id, windowName, articleName, productId) {
    var _this;

    _classCallCheck(this, DummyWindow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DummyWindow).call(this));
    _this.id = id;
    _this.windowName = windowName;
    _this.articleName = articleName;
    _this.productId = productId;
    return _this;
  }

  return DummyWindow;
}(DomainObject_1.DomainObject);

exports.DummyWindow = DummyWindow;

DummyWindow.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(DummyWindow.name);
  return {
    id: builder.id('id'),
    windowName: builder.trimStr('windowName', new StringLengthValidator_1.StringLengthValidator(3, 255)),
    articleName: builder.trimStr('articleName', new StringLengthValidator_1.StringLengthValidator(3, 255)),
    productId: builder.str('productId')
  };
}();